import { Link } from "react-router-dom";
import styles from './LandingPage.module.css';

export default function LandingPage() {
    return (
        <section className={styles.landingSection}>
            <div className={styles.content}>
                <div className={styles.ctaDiv}>
                    <h1>Now Make It Yours</h1>
                    <h2>Explore our packages</h2>
                    <Link 
                        to={"/visualizer/package/package1/spec/"+encodeURIComponent('Demo\\Cambridge_Homes\\Kitchen(qfactor=(10,4))')+"/sel/5088644,5088648,5088650,5088647,5088652,5088649,5088652,5088651"} 
                        className={styles.btnPrimary}
                    >
                        Get Started
                    </Link>
                </div>  
            </div>
        </section>
    );
}
